import { getTransform } from "./qaConfig"

const getTenant_CRUD_Config = {
  ...getTransform("dk_tenant_create_button"),
  ...getTransform("dk_tenant_submit_button"),
  ...getTransform("dk_tenant_cancel_button"),
  ...getTransform("dk_tenant_list_heading_label"),
  ...getTransform("dk_tenant_admin_list_heading_label"),
  ...getTransform("dk_tenant_configuration_list_heading_label"),
  ...getTransform("dk_tenant_name_common_input"),
  ...getTransform("dk_tenant_name_common_error"),
  ...getTransform("dk_tenant_web_address_value_label"),
  ...getTransform("dk_tenant_web_address_common_key_label"),
  ...getTransform("dk_tenant_web_address_common_error"),
  ...getTransform("dk_tenant_web_address_common_input"),
  ...getTransform("dk_tenant_phone_number_value_label"),
  ...getTransform("dk_tenant_phone_number_common_key_label"),
  ...getTransform("dk_tenant_phone_number_common_error"),
  ...getTransform("dk_tenant_phone_number_common_input"),
  ...getTransform("dk_tenant_phone_number_common_dropdown"),
  ...getTransform("dk_tenant_fax_code_value_label"),
  ...getTransform("dk_tenant_fax_code_common_key_label"),
  ...getTransform("dk_tenant_fax_code_common_error"),
  ...getTransform("dk_tenant_fax_code_common_input"),
  ...getTransform("dk_tenant_tax_provider_value_label"),
  ...getTransform("dk_tenant_tax_provider_common_key_label"),
  ...getTransform("dk_tenant_tax_provider_common_error"),
  ...getTransform("dk_tenant_tax_provider_common_input"),
  ...getTransform("dk_tenant_currency_value_label"),
  ...getTransform("dk_tenant_currency_common_key_label"),
  ...getTransform("dk_tenant_currency_common_error"),
  ...getTransform("dk_tenant_currency_common_input"),
  ...getTransform("dk_tenant_currency_common_dropdown"),
  ...getTransform("dk_tenant_languages_value_label"),
  ...getTransform("dk_tenant_languages_common_key_label"),
  ...getTransform("dk_tenant_languages_common_error"),
  ...getTransform("dk_tenant_languages_common_input"),
  ...getTransform("dk_tenant_address_line1_value_label"),
  ...getTransform("dk_tenant_address_line1_common_key_label"),
  ...getTransform("dk_tenant_address_line1_common_error"),
  ...getTransform("dk_tenant_address_line1_common_input"),
  ...getTransform("dk_tenant_address_line2_value_label"),
  ...getTransform("dk_tenant_address_line2_common_key_label"),
  ...getTransform("dk_tenant_address_line2_common_input"),
  ...getTransform("dk_tenant_country_value_label"),
  ...getTransform("dk_tenant_country_common_key_label"),
  ...getTransform("dk_tenant_country_common_error"),
  ...getTransform("dk_tenant_country_common_input"),
  ...getTransform("dk_tenant_state_value_label"),
  ...getTransform("dk_tenant_state_common_key_label"),
  ...getTransform("dk_tenant_state_common_error"),
  ...getTransform("dk_tenant_state_common_input"),
  ...getTransform("dk_tenant_city_value_label"),
  ...getTransform("dk_tenant_city_common_key_label"),
  ...getTransform("dk_tenant_city_common_error"),
  ...getTransform("dk_tenant_city_common_input"),
  ...getTransform("dk_tenant_zip_code_value_label"),
  ...getTransform("dk_tenant_zip_code_common_key_label"),
  ...getTransform("dk_tenant_zip_code_common_error"),
  ...getTransform("dk_tenant_zip_code_common_input"),
  ...getTransform("dk_tenant_admin_title_common_error"),
  ...getTransform("dk_tenant_admin_title_common_input"),
  ...getTransform("dk_tenant_admin_first_name_common_error"),
  ...getTransform("dk_tenant_admin_first_name_common_input"),
  ...getTransform("dk_tenant_admin_last_name_common_error"),
  ...getTransform("dk_tenant_admin_last_name_common_input"),
  ...getTransform("dk_tenant_admin_gender_value_label"),
  ...getTransform("dk_tenant_admin_gender_common_key_label"),
  ...getTransform("dk_tenant_admin_gender_common_error"),
  ...getTransform("dk_tenant_admin_gender_common_input"),
  ...getTransform("dk_tenant_admin_email_address_value_label"),
  ...getTransform("dk_tenant_admin_email_address_common_key_label"),
  ...getTransform("dk_tenant_admin_email_address_common_error"),
  ...getTransform("dk_tenant_admin_email_address_common_input"),
  ...getTransform("dk_tenant_admin_phone_number_value_label"),
  ...getTransform("dk_tenant_admin_phone_number_common_key_label"),
  ...getTransform("dk_tenant_admin_phone_number_common_error"),
  ...getTransform("dk_tenant_admin_phone_number_common_input"),
  ...getTransform("dk_tenant_admin_phone_number_common_dropdown"),
  ...getTransform("dk_tenant_admin_address_line1_value_label"),
  ...getTransform("dk_tenant_admin_address_line1_common_key_label"),
  ...getTransform("dk_tenant_admin_address_line1_common_error"),
  ...getTransform("dk_tenant_admin_address_line1_common_input"),
  ...getTransform("dk_tenant_admin_address_line2_value_label"),
  ...getTransform("dk_tenant_admin_address_line2_common_key_label"),
  ...getTransform("dk_tenant_admin_address_line2_common_input"),
  ...getTransform("dk_tenant_admin_country_value_label"),
  ...getTransform("dk_tenant_admin_country_common_key_label"),
  ...getTransform("dk_tenant_admin_country_common_error"),
  ...getTransform("dk_tenant_admin_country_common_input"),
  ...getTransform("dk_tenant_admin_state_value_label"),
  ...getTransform("dk_tenant_admin_state_common_key_label"),
  ...getTransform("dk_tenant_admin_state_common_error"),
  ...getTransform("dk_tenant_admin_state_common_input"),
  ...getTransform("dk_tenant_admin_city_value_label"),
  ...getTransform("dk_tenant_admin_city_common_key_label"),
  ...getTransform("dk_tenant_admin_city_common_error"),
  ...getTransform("dk_tenant_admin_city_common_input"),
  ...getTransform("dk_tenant_admin_zip_code_value_label"),
  ...getTransform("dk_tenant_admin_zip_code_common_key_label"),
  ...getTransform("dk_tenant_admin_zip_code_common_error"),
  ...getTransform("dk_tenant_admin_zip_code_common_input"),
  ...getTransform("dk_tenant_cofiguration_loyalty_functionality_value_label"),
  ...getTransform("dk_tenant_cofiguration_loyalty_functionality_common_key_label"),
  ...getTransform("dk_tenant_admin_loyalty_switch"),
}
console.log("getTenant_CRUD_Config", getTenant_CRUD_Config)

export { getTenant_CRUD_Config }
